import { BaseHeading } from "./BaseHeading.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/headings/Heading3.tsx
const Heading3 = ({ children, color = "gray", size = "h3", ta, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(BaseHeading, {
		order: 3,
		size,
		color,
		ta,
		"data-testid": testId,
		children
	});
};

//#endregion
export { Heading3 };